module.exports = __webpack_public_path__ + "img/magic-brand.ea2068f7.png";